<template>
  <v-app>
    <component :is="layout" />
    <!-- <core-filter />

    <core-toolbar />

    <core-drawer />

    <core-view /> -->
  </v-app>
</template>

<script>
  const defaultLayout = 'public'
  export default {
    computed: {
      layout () {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    },
    mounted() {
      if (window.location.href.includes('totem')) {
        const styleKiosk = document.createElement('style')
        styleKiosk.id = 'style-totem'
        styleKiosk.innerHTML = `
          * {
            -webkit-touch-callout: none !important;
            -webkit-user-select: none !important;
            user-select: none !important;
          }
          input, textarea, [contenteditable="true"] {
            -webkit-touch-callout: default !important;
            -webkit-user-select: text !important;
            user-select: text !important;
          }
        `
        document.head.appendChild(styleKiosk)

        document.addEventListener('contextmenu', this.blockContextMenu, { passive: false })
        
        console.log("Vue Kiosk: Modo Tótem activado globalmente.")
      }
    },
    methods: {
      blockContextMenu (e) {
        e.preventDefault()
      }
    },
    beforeUnmount() {
      document.removeEventListener('contextmenu', this.blockContextMenu)
    },
  }
</script>

<style>
html {
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
html::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
}
</style>
<!--style lang="scss">
  // @import '@/styles/index.scss';
</style-->
